<template>
  <div id="fomulario_PersonaMoral">
    <div class="row">
      <div class="col-8">
        <h6>
          Nombre 
          <i v-if="mostrarErroresEnFormulario && !this.cadenaEsVaciaONula(personaMoral.Nombre)" class="fas fa-check-circle text-success font-size: 15px;"></i>
          <i v-if="mostrarErroresEnFormulario && this.cadenaEsVaciaONula(personaMoral.Nombre)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
        </h6>
        <input type="text" id="nombrePersonaMoral" placeholder = "Ingrese nombre de la persona Moral" v-model="personaMoral.Nombre" place :class="[mostrarErroresEnFormulario && this.cadenaEsVaciaONula(personaMoral.Nombre) ? 'form-control border border-danger' : 'form-control']" />
      </div>
      <div class="col-4">
        <h6>
          Tipo Personalidad
          <i v-if="mostrarErroresEnFormulario && parametros_TipoPersonalidad.tipoPersonalidadId > 0" class="fas fa-check-circle text-success font-size: 15px;"></i>
          <i v-if="mostrarErroresEnFormulario && parametros_TipoPersonalidad.tipoPersonalidadId < 0" class="fas fa-times-circle text-danger font-size: 25px;"></i>
        </h6>
        <C029TiposPersonalidades 
          v-on:valorParaElPadre="cambioDeTipoDePersonalidad"
          :prefijo="enumeraciones.etiquetasDeHTML.Select" 
          :tipo="enumeraciones.tiposDeSelect.Seleccione" 
          :idDelInput="'personaMoral_TipoPersonalidad'" 
          :parametros="parametros_TipoPersonalidad.parametros" 
          :valorDefinido="parametros_TipoPersonalidad.tipoPersonalidadId" 
          :key="parametros_TipoPersonalidad.key"></C029TiposPersonalidades>
      </div>      
      <div class="col-12">
        <CFormularioRepresentantesLegales
                :idFormulario="'personaMoral_RepresentantesLegales'"
                :ref="'personaMoral_RepresentantesLegales'"                
                v-on:obtenerListadoDeRepresentantesLegales="obtenerListadoDeRepresentantesLegales"></CFormularioRepresentantesLegales>
        <br/>        
      </div>  
      <div class="d-flex justify-content-end col-12">                  
        <div><button type="button" @click="guardarPersonaMoral({ evento: null, conMensaje: true })" class="btn btn-primary"><i class="fas fa-plus-square"></i>&nbsp;&nbsp;Agregar persona moral</button></div>        
      </div>                      
    </div>
  </div>
</template>
<script>
import catalogos from '@/../static/js/catalogos'
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import CFormularioRepresentantesLegales from '../../Comun/CFormularioRepresentantesLegales.vue'
import api from '@/../static/js/api'
import axios from 'axios'

export default {
  components: {
    C029TiposPersonalidades: catalogos.PJ.C029TipoPersonalidad,
    CFormularioRepresentantesLegales: CFormularioRepresentantesLegales
  },
  data: () => {
    return{
      empresaEntidadObj: null,
      enumeraciones,      
      personaMoral: {
        Nombre: "",        
        RepresentantesLegales: []
      },
      RepresentantesLegales: [],
      parametros_TipoPersonalidad: {
        key: "",
        tipoPersonalidadId: -1,
        parametros: {}
      },
      mostrarErroresEnFormulario: false
    }
  },
  props: {    
    personaMoralEditar: null
  },  
  computed :{   
  },
  mounted(){  
    if(Object.entries(this.personaMoralEditar).length > 0)//if(this.personaMoralEditar != null) 
    {     
      console.log(this.personaMoralEditar);
      this.personaMoral = this.personaMoralEditar.DatosGenerales.Moral;
      this.parametros_TipoPersonalidad.tipoPersonalidadId = this.personaMoralEditar.TipoPersonalidad.TipoPersonalidadId;
      this.parametros_TipoPersonalidad.key = "tipopersonalidadEditar_" + this.personaMoralEditar.MoralId;
      this.cargarRepresentantesLegales();
    }
  },
  created() {
    this.parametros_TipoPersonalidad.parametros.MateriaId = this.$store.state.PJ_Catalogos_002Materias["filtro-materia-creacionCedula"];
  },
  methods: {
    cargarRepresentantesLegales: function(){ 
      if(this.personaMoral.RepresentantesLegales != null && this.personaMoral.RepresentantesLegales.length > 0) {               
        this.$refs['personaMoral_RepresentantesLegales'].representantesLegales = this.personaMoral.RepresentantesLegales.map(representante => {          
          let representanteObj = {
            representanteLegal: representante,
            idReferencia: null
          }
          return representanteObj;
        });
        
        let representantesFormatoTabla = [];
        let contRepresentantes = 1;
        this.$refs['personaMoral_RepresentantesLegales'].representantesLegales.forEach(represntante => {
          represntante.idReferencia = contRepresentantes;
          const nombre = [represntante.representanteLegal.DatosGenerales.Fisica.Nombre, represntante.representanteLegal.DatosGenerales.Fisica.ApellidoPaterno, represntante.representanteLegal.DatosGenerales.Fisica.ApellidoMaterno]
          const nombre_completo = nombre.join(' ');
          
          let objRepresentanteTabla = {
              Folio: contRepresentantes,
              Representante: nombre_completo
          }
          
          representantesFormatoTabla.push(objRepresentanteTabla);
          contRepresentantes ++;
        });
        
        this.$refs['personaMoral_RepresentantesLegales'].representantesLegalesTabla = representantesFormatoTabla;
        this.$refs['personaMoral_RepresentantesLegales'].contadorRepresentantesLegales = representantesFormatoTabla.length;        
      }
    },
    cambioDeTipoDePersonalidad: function(datos){      
      this.parametros_TipoPersonalidad.tipoPersonalidadId = parseInt(datos.target.value); 
    },
    obtenerListadoDeRepresentantesLegales: function(evento){
      this.RepresentantesLegales = evento;
    },
    cadenaEsVaciaONula: function(cadena) {
      let esVaciaONula = false;
      if(cadena == null || cadena == '' || cadena == undefined) {
        esVaciaONula = true;
      }
      return esVaciaONula;
    },
    validarPersonaMoral: function(){
      if(!this.cadenaEsVaciaONula(this.personaMoral.Nombre))        
        return true;
      if(this.parametros_TipoPersonalidad.tipoPersonalidadId != "-1" && this.parametros_TipoPersonalidad.tipoPersonalidadId != null)
        return true;

      return false;
    },
    guardarPersonaMoral: function({ evento, conMensaje = true }){         
      if(this.validarPersonaMoral()){                
        this.personaMoral.RepresentantesLegales = [];        
        this.RepresentantesLegales.forEach(element => { 
          console.log(element.representanteLegal);
          this.personaMoral.RepresentantesLegales.push(element.representanteLegal);    
        });      
        const peticion = {
          persona:{
            DatosGenerales: { Moral : this.personaMoral },
            TipoPersonalidad: this.parametros_TipoPersonalidad,
            TipoPersona: {
              TipoPersonaId: enumeraciones.pj.tiposPersonas.Moral
            },
            Domicilios:{}     
          }   
        }
               
        this.mostrarErroresEnFormulario = false;
        if(conMensaje)
          comun.mensajeDeAlerta("La persona moral se ha agregado correctamente", null, null);  
                 
        this.$emit('obtenerPersonaMoral', peticion);           
      }else{
        this.mostrarErroresEnFormulario = true;
        if(conMensaje)
          comun.mensajeDeAlerta('Se detectaron campos incorrectos. Favor de verificarlos.', null, null);
      }
    },
    evtGuardarEmpresa: function(peticion) {   // new   
      const SERVIDOR = api.conexion;
            const METODO_API_GUARDAR = api.SINOJ.sistema.cedulas.creacion.GuardarPersonaMoral;
            let urlApi = SERVIDOR + METODO_API_GUARDAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticion, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        comun.SeEstaCargandoInformacion(false);                                             
                        //this.limpiarPersonaMoral();                        
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);                        
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
            );             
    }, // fin new
    limpiarPersonaMoral: function(){
      this.personaMoral.Nombre = "";
      this.personaMoral.RepresentantesLegales = [];
      this.RepresentantesLegales = [];
      this.parametros_TipoPersonalidad.key = "",
      this.parametros_TipoPersonalidad.tipoPersonalidadId = -1;        
      this. mostrarErroresEnFormulario = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/Creacion/CFormularioPersonaMoral.vue